// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import icons from "../../../icons.config";
// import { IMAGE_BASE_URL } from "../../../api-urls";

// const Blogs = ({ data }) => {
//   const initialImages = data?.map((item) => ({
//     image: item.thumbnail,  // ✅ Correctly accessing 'thumbnail'
//     alt: item.title,
//     description: item.blog,
//     cImage: item.thumbnail,
//   })) || []; // Fallback to an empty array if 'data' is undefined
  

//   const [imageList, setImageList] = useState(initialImages);
//   const [activeImageIndex, setActiveImageIndex] = useState(initialImages.length - 1);
//   const [isFading, setIsFading] = useState(false);

//   const fadeVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { duration: 0.3 } },
//     exit: { opacity: 0, transition: { duration: 0.5 } },
//   };

//   const handleImageClick = (clickedIndex) => {
//     const newImageList = [...imageList];
//     const bigImage = newImageList[activeImageIndex];
//     const clickedImage = newImageList.splice(clickedIndex, 1)[0];
//     newImageList.splice(activeImageIndex, 1);

//     const clickedImageWithCImage = {
//       ...clickedImage,
//       image: clickedImage.cImage,
//     };

//     newImageList.splice(activeImageIndex, 0, clickedImageWithCImage);
//     newImageList.push(bigImage);

//     setImageList(newImageList);
//   };

//   const navigate = useNavigate();
//   const goToBlogs = () => {
//     navigate("/blogs");
//   };

//   return (
//     <section className="overflow-hidden bg-tertiary">
//       <div className="flex flex-col lg:flex-row lg:space-x-8 py-0 px-6 lg:px-20">
//         <div className="lg:w-1/2 relative">
//           <h2 className="text-5xl font-outfit font-light text-primary1 mb-6 text-center lg:text-left">
//             BLOGS
//           </h2>
//           <p className="text-sm text-[#650D1B] font-poppins font-light mb-8">
//             Explore the latest collections, discover tips, and stay updated with trending styling tips and expert advice.
//           </p>
//           <div className="hidden lg:grid grid-cols-2 gap-4">
//             {imageList.slice(0, 4).map((img, index) => (
//               <motion.div key={index} className="cursor-pointer" onClick={() => handleImageClick(index)}>
//                 <motion.img src={IMAGE_BASE_URL+img.image} alt={img.alt} className="w-full h-auto" />
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         <div className="lg:w-1/2 relative">
//           <motion.div key={activeImageIndex} variants={fadeVariants} initial="hidden" animate="visible" exit="exit">
//             <img src={IMAGE_BASE_URL+imageList[activeImageIndex].image} alt={imageList[activeImageIndex].alt} className="w-full h-auto" />
//             <div className="absolute bg-red-opacity-80 p-4">
//               <h3 className="text-primary1 text-3xl font-outfit font-light">{imageList[activeImageIndex].alt}</h3>
//               <p className="text-hcolor text-xs font-poppins font-normal">{imageList[activeImageIndex].description}</p>
//             </div>
//             <div className="cursor-pointer" onClick={goToBlogs}>
//               <img src={icons.blogArrow} alt="Arrow Icon" className="w-9 h-9" />
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Blogs;



import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import icons from "../../../icons.config";
import { IMAGE_BASE_URL } from "../../../api-urls";

const Blogs = ({ data }) => {
  const initialImages = data?.map((item) => ({
    image: item.thumbnail,
    alt: item.title,
    description: item.blog,
    cImage: item.thumbnail,
  })) || [];

  const [imageList, setImageList] = useState(initialImages);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.5 } },
  };

  const handleImageClick = (clickedIndex) => {
    setIsFading(true);
    setTimeout(() => {
      const newImageList = [...imageList];
      
      // Adjust the clicked index since slice(1, 5) starts from index 1 in the array
      const actualClickedIndex = clickedIndex + 1;

      // Swap the big blog (index 0) with the clicked small blog
      const temp = newImageList[0]; // Store the big blog
      newImageList[0] = newImageList[actualClickedIndex]; // Move small blog to big blog position
      newImageList[actualClickedIndex] = temp; // Move big blog to small blog position

      // Update the state
      setImageList(newImageList);
      setActiveImageIndex(0); // Big blog is always at index 0
      setIsFading(false);
    }, 500);
  };

  const navigate = useNavigate();
  const goToBlogs = () => {
    navigate("/blogs");
  };

  if (!data || initialImages.length === 0) {
    return null;
  }

  return (
    <section className="overflow-hidden bg-tertiary">
      <div className="left-0 bottom-12 lg:bottom-8 xl:bottom-20 relative">
        <img src={icons.blogCircles} alt="Doodle Left" className="w-40 lg:w-1/5" />
      </div>

      {/* Main Container with Responsive Flex Layout */}
      <div className="flex flex-col lg:flex-row lg:space-x-8 py-0 px-6 lg:px-20 md:-mb-20 lg:-mb-16 xl:-mb-48 2xl:-mb-32">
        <div className="lg:w-1/2 relative">
          {/* Left Section with Text */}
          <div className="relative bottom-24 md:bottom-20 lg:bottom-14 px-3 lg:px-12 left-3 lg:left-1">
            <h2 className="text-5xl font-outfit font-light text-primary1 mb-6 text-center lg:text-left">
              BLOGS
            </h2>
            <p className="text-sm text-[#650D1B] font-poppins font-light mb-8 relative top-4 md:pr-2 lg:pr-0">
              {data.description ||
                "Explore the latest collections, discover tips or find your perfect fit, and learn about luxurious fabrics. Stay inspired and updated with fresh insights, trending styling tips, expert advice and famous fashion stories to elevate your wardrobe and upgrade your style."}
            </p>

            {/* New Container for Small Images */}
            <div className="hidden lg:grid grid-cols-2 gap-4 lg:gap-6 relative z-10">
              {imageList.slice(1, 5).map((img, index) => (
                <motion.div
                  key={index + 1}
                  className={`cursor-pointer ${isFading ? "opacity-0" : "opacity-100"} transition-opacity duration-500 aspect-[4/3]`}
                  onClick={() => handleImageClick(index)} // Pass the index from slice(1, 5)
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <motion.img
                    src={IMAGE_BASE_URL + img.image}
                    alt={img.alt}
                    className="w-full h-full object-fit"
                    variants={fadeVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Section with Big Image */}
        <div className="lg:w-1/2 relative -top-20 md:-top-14 lg:left-7 lg:-top-20 xl:-top-24 left-5 xl:left-3 md:flex md:flex-col z-10 h-[500px] lg:h-[500px] xl:h-[650px] 2xl:h-[660px] pr-9 md:pr-10 xl:pr-16">
          <motion.div
            key={activeImageIndex}
            className="relative w-full h-full"
            variants={fadeVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {/* Image */}
            <img
              src={IMAGE_BASE_URL + imageList[activeImageIndex].image}
              alt={imageList[activeImageIndex].alt}
              className={`w-full h-full object-cover transition-opacity duration-500 ${
                isFading ? "opacity-0" : "opacity-100"
              }`}
            />

            {/* Overlay Container */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 bg-black/40 text-white">
              {/* Title */}
              <h3 className="text-3xl font-outfit font-light mb-2">
                {imageList[activeImageIndex].alt}
              </h3>

              {/* Description */}
              <p className="text-xs font-poppins font-normal pr-20">
                {imageList[activeImageIndex].description.split(" ").slice(0, 20).join(" ")}
                {imageList[activeImageIndex].description.split(" ").length > 20 ? "..." : ""}
              </p>
            </div>

            {/* Arrow Icon */}
            <div className="absolute bottom-10 right-6 cursor-pointer">
              <img
                src={icons.blogArrow}
                alt="Arrow Icon"
                className="w-6 h-6 lg:w-9 lg:h-9"
                onClick={goToBlogs}
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Small Images for Small and Medium Screens */}
      <div className="grid grid-cols-2 gap-4 lg:hidden relative bottom-14 md:-bottom-10 px-10 z-10">
        {imageList.slice(1, 5).map((img, index) => (
          <motion.div
            key={index + 1}
            className="cursor-pointer w-full h-[150px] transition-opacity duration-500"
            onClick={() => handleImageClick(index)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.img
              src={IMAGE_BASE_URL + img.image}
              alt={img.alt}
              className="w-full h-full object-cover"
              variants={fadeVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            />
          </motion.div>
        ))}
      </div>

      <div className="relative -top-24 md:-top-10 xl:top-12 2xl:-top-14 -right-[86%] md:-right-[90%] xl:-right-[86%] 2xl:-right-[87%] -bottom-[22%] xl:pb-12 2xl:pb-0">
        <img
          src={icons.blogCirclesDown}
          alt="Arrow Icon"
          className="w-24 lg:w-48 xl:w-52"
        />
      </div>
    </section>
  );
};

export default Blogs;